/**
 * IMPORTANT: use this file only to import element from outside of package.
 */

import meta from '../../package.json';
import es from '../i18n/es.json';

export * from './apiConfig';
export { default as modalsConfig } from './modalsConfig';
export { default as rolesConfig } from './rolesConfig';
export * as documentType from './documentType';
export * as themesType from './themesType';
export * as documentState from './documentState';
export * as settingLevel from './settingLevel';
export * as formatReportType from './formatReportType';
export * as routes from './routes';

export const I18N = {
  namespace: meta.name,
  bundles: {
    es
  }
};
